import { ReactNode } from 'react';
import styles from './Card.module.css';

export interface CardProps {
    children: ReactNode;
    className?: string;
    onClick?: () => void;
}

export interface CardHeaderProps {
    children: ReactNode;
    actions?: ReactNode;
}

export interface CardBodyProps {
    children: ReactNode;
}

export interface CardFooterProps {
    children: ReactNode;
}

export const Card = ({ children, className = '', onClick }: CardProps) => {
    return (
        <div
            className={`${styles.card} ${className} ${onClick ? styles.clickable : ''}`}
            onClick={onClick}
        >
            {children}
        </div>
    );
};

export const CardHeader = ({ children, actions }: CardHeaderProps) => {
    return (
        <div className={styles.cardHeader}>
            <div className={styles.cardTitle}>{children}</div>
            {actions && <div className={styles.cardActions}>{actions}</div>}
        </div>
    );
};

export const CardBody = ({ children }: CardBodyProps) => {
    return <div className={styles.cardBody}>{children}</div>;
};

export const CardFooter = ({ children }: CardFooterProps) => {
    return <div className={styles.cardFooter}>{children}</div>;
};
